<template>
  <div class="base-info">
    <resource-list-page-content :pageData="pageData" :cols="cols" v-loading="loading" :showIndex="true" :headerCellStyle="headerCellStyle" />
    <resource-list-page-footer />
  </div>
</template>

<script>
import ResourceListPageContent from 'common/ResourceListPageContent'
import ResourceListPageFooter from 'common/ResourceListPageFooter'
export default {
  name: 'DimensionInfo',
  components: {
    ResourceListPageContent,
    ResourceListPageFooter
  },
  provide () {
    return {
      pageOption: this.pageOption
    }
  },
  props: {
    company: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selectKey: {
      type: String,
      default: ''
    },
    selectType: {
      type: String,
      default: 'resources'
    }
  },
  computed: {
    pageData: function () {
      return this.dimensionInfo.map(item => item.info)
    },
    cols: function () {
      if (this.dimensionInfo.length === 0) return []
      let info = this.dimensionInfo[0].info
      return Object.keys(info).filter(key => key !== '企业名称').map(key => ({
        label: key,
        prop: key,
        width: '220',
        isNowrap: true
      }))
    }
  },
  watch: {
    company: {
      immediate: true,
      handler (val) {
        if (this.selectType === 'resources') {
          if (val.key === this.selectKey) this.fetchData()
        } else {
          if (val.key === this.selectKey) this.fetchCompanyData()
        }
      }
    },
    'pageOption.currentPage': {
      handler (newVal) {
        this.fetchData()
      }
    },
    'pageOption.pageSize': {
      handler (newVal) {
        this.fetchData()
      }
    }
  },
  data () {
    return {
      dimensionInfo: [],
      loading: false,
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示条数
      },
      keys: {
        order_num: '订单编号',
        order_status: '订单状态',
        total_amount: '订单金额',
        is_renew: '订单续费',
        advisor: '订单顾问',
        converter: '转化人',
        operator_name: '服务人员',
        order_reg: '订单类型',
        order_park: '园区',
        assign_at: '派单时间',
        created_at: '录入时间'
      },
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$axios.get('/api/admin/upload_tasks/key/page/risks?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + '&company_name=' + this.company.company_name + '&key=' + this.company.key, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.dimensionInfo = data.data.data
            this.pageOption.total = data.data.total
            this.loading = false
          }
        })
    },
    fetchCompanyData () {
      this.loading = true
      this.$axios.get('/api/admin/upload_task_info/company_data?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + '&company_name=' + this.company.company_name + '&key=' + this.company.key, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.dimensionInfo = this.transformData(data.data.data)
            console.log('dimensionInfo', this.dimensionInfo)
            this.pageOption.total = data.data.total
            this.loading = false
          }
        })
    },
    transformData (data) {
      return data.map(item => {
        const info = {};
        for (const [key, label] of Object.entries(this.keys)) {
          if (item[key] !== undefined && item[key] !== null) {
            if (key === 'order_reg' && item[key].order_reg_name) {
              info[label] = item[key].order_reg_name
            } else if (key === 'advisor' && item[key].username) {
              info[label] = item[key].username
            } else if (key === 'converter' && item[key].username) {
              info[label] = item[key].username
            } else {
              info[label] = item[key]
            }
          } else {
            info[label] = key === 'converter' ? '自助下单' : ''
          }
        }
        return { info } // 将重新组合的数据包裹在 info 中
      })
    },
    headerCellStyle () {
      return {
        backgroundColor: '#f2f9fc'
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/DimensionInfo.vue